import {
	FormItem,
	MultiSelect,
	MultiSelectItem,
	ValidationError
} from "client/Components";
import { ReactElement } from "react";
import { localize } from "client_legacy/ndaw/culture";
import { IValueInputAttachable } from "client/Forms/attachable";
import { AppointmentDayOfWeek } from "client/Api/Calendar/calendar";
import {
	DayOfWeek,
	formatDayOfWeek,
	getFirstWeekDay,
	getWeekDays
} from "client/DateAndTime/culture";
import { WeeklyCustomRecurrenceOptionsModel } from "../../common";

export type WeeklyCustomOptionSelectorProps = {
	handler: IValueInputAttachable<WeeklyCustomRecurrenceOptionsModel>;
};

export const WeeklyCustomOptionSelector = (props: WeeklyCustomOptionSelectorProps): ReactElement => {
	const {
		handler
	} = props;

	const repeatOnHandler: IValueInputAttachable<readonly AppointmentDayOfWeek[]> = handler.for("daysOfWeek");

	return (
		<FormItem
			label={localize("_RepeatOn")}
			isRequired
		>
			<MultiSelect
				{...repeatOnHandler.attachToMultiSelect()}
				options={options}
				menuTitle={localize("_RepeatOn")}
				placeholder={localize("_SelectDay(s)")}
			/>
			<ValidationError {...repeatOnHandler.attachToValidationError()} />
		</FormItem>
	);
};
WeeklyCustomOptionSelector.displayName="WeeklyCustomOptionSelector";

export const dayOfWeekToAppointmentDayOfWeekMap: {[key in DayOfWeek]: AppointmentDayOfWeek} = {
	[DayOfWeek.Sunday]: AppointmentDayOfWeek.Sunday,
	[DayOfWeek.Monday]: AppointmentDayOfWeek.Monday,
	[DayOfWeek.Tuesday]: AppointmentDayOfWeek.Tuesday,
	[DayOfWeek.Wednesday]: AppointmentDayOfWeek.Wednesday,
	[DayOfWeek.Thursday]: AppointmentDayOfWeek.Thursday,
	[DayOfWeek.Friday]: AppointmentDayOfWeek.Friday,
	[DayOfWeek.Saturday]: AppointmentDayOfWeek.Saturday,
};

const firstWeekDay: DayOfWeek = getFirstWeekDay();
const options: readonly MultiSelectItem<AppointmentDayOfWeek>[] = getWeekDays(firstWeekDay)
	.map(
		(d: DayOfWeek): MultiSelectItem<AppointmentDayOfWeek> => ({
			text: formatDayOfWeek(d, "full"),
			value: dayOfWeekToAppointmentDayOfWeekMap[d]
		})
	);